import { DocumentKeyEnum } from './enums/DocumentKeyEnum';
const AUTO_HIDE_DELAY = 2000; // 2s
let gMain;
const init = (main) => {
    gMain = main;
};
const notify = (title, msg, variant) => {
    if (!gMain) {
        return;
    }
    const main = gMain;
    main.$bvToast.toast(msg, {
        title,
        variant,
        solid: true,
        visible: true,
        autoHideDelay: AUTO_HIDE_DELAY,
    });
};
const secondary = (title, msg) => {
    notify(title, msg, 'secondary');
};
const warning = (title, msg) => {
    notify(title, msg, 'warning');
};
const danger = (title, msg) => {
    notify(title, msg, 'danger');
};
const success = (title, msg) => {
    notify(title, msg, 'success');
};
const info = (title, msg) => {
    notify(title, msg, 'info');
};
const notifyHelper = {
    init,
    notify,
    secondary,
    warning,
    danger,
    success,
    info,
};
const doc = document;
if (!doc[DocumentKeyEnum.Notify]) {
    doc[DocumentKeyEnum.Notify] = notifyHelper;
}
export { notifyHelper, };
